<template>
  <div class="space-y-8">
    <div>
      <ProjectAddAction :product-id="productId" @project-added="onProjectAdded" />
    </div>
    <div>
      <ProjectList ref="projectList" :product-id="productId" @change="$emit('refresh')" />
    </div>
  </div>
</template>

<script>
import ProjectAddAction from './ProjectAddAction.vue';
import ProjectList from './ProjectList.vue';

export default {
  components: { ProjectList, ProjectAddAction },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  methods: {
    onProjectAdded() {
      this.$refs.projectList.refreshList();
    },
  },
};
</script>
